var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SortableList',{ref:"sortableList"}),_c('b-button',{style:({ float: 'right' }),on:{"click":_vm.add}},[_vm._v("add")]),_c('b-input',{model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }